import React from 'react'

const Success = ({ className = '', width = '1em', height = '1em', ...props }) => (
  <svg
    className={`ac-icon ac-icon__success ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2m5.835 5.748l-.728-.63a.485.485 0 0 0-.68.045l-6.364 7.197-2.502-2.752a.487.487 0 0 0-.683-.036l-.718.638a.476.476 0 0 0-.036.677l2.66 2.92-.004.004.942 1.031c.194.213.531.21.721-.006l.92-1.039h-.002l6.52-7.373a.477.477 0 0 0-.046-.676' />
  </svg>
)

export default Success
